import CreateTicketButton from './CreateTicketButton/CreateTicketButton';
import TicketList from './TicketList/TicketList';
import TicketPopup from './TicketPopup/TicketPopup';
import { useDispatch } from "react-redux";
import { useState, useEffect } from 'react';
import { fetchAllTickets } from '../../slices/TicketSlice';
import "./StudentTicketDashboard.scss";




/**
 * StudentTicketDashboard Component
 *
 * @component
 * @description
 * Displays a dashboard for students to manage their tickets. Includes:
 * - A button to create new tickets (opens a popup).
 * - A list of the student's tickets.
 * - A modal to view detailed ticket information.
 *
 * @returns {JSX.Element} The student ticket dashboard UI.
 *
 * @example
 * // Usage:
 * <StudentTicketDashboard />
 */

export default function StudentTicketDashboard() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAllTickets());
  }, [dispatch]);

 const togglePopup = () => {
   setIsPopupOpen(prev => !prev);
 };
 
useEffect(() => {
  // Get body element and add class on mount
  document.body.classList.add("student-dashboard-active");

  return () => {
    // Cleanup: Remove the class when the component unmounts
    document.body.classList.remove("student-dashboard-active");
  };
}, []); // run once, on mount and cleanup on unmount

  return (
    //<TicketList />
    <div data-testid="StudentTicketDashboard" className="student-ticket-dashboard-container"> {/*"student-ticket-dashboard-container" class includes header and footer (aka new ticket button & "my tickets")*/}
      <div className="ticket-list-container" data-testid="ticket-list-container">
        <CreateTicketButton onOpen={togglePopup} data-testid="create-ticket-button"/>      
        <TicketList width={"330px"} user={"student"} data-testid="ticket-list"/>
      </div>
      {isPopupOpen && (
        <TicketPopup onClose={togglePopup} data-testid="ticket-popup"/>
      )}
    </div>
  );
}
